import { useMemo } from 'react';

import { InvestorStatus } from '../investments.types';

import useInvestmentsHoldings from './useInvestmentsHoldings';
import useInvestor from './useInvestor';

interface Params {
  accountId?: string;
}

export default ({ accountId }: Params) => {
  const {
    data: { status, isInvestmentModelSwitching, isFullLiquidationInProgress, pendingTradesAmount },
  } = useInvestor(accountId);
  const { details } = useInvestmentsHoldings(accountId);

  const isFullLiquidation = useMemo(() => {
    return isFullLiquidationInProgress;
  }, [isFullLiquidationInProgress]);

  const isFullLiquidated = useMemo(() => {
    if (status === InvestorStatus.ACTIVE) {
      return details.portfolioBalance === 0 && !isInvestmentModelSwitching && pendingTradesAmount === 0;
    }
    return false;
  }, [details.portfolioBalance, isInvestmentModelSwitching, pendingTradesAmount, status]);

  return {
    isFullLiquidation,
    isFullLiquidated,
    isLoading: false,
  };
};
